import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import classes from "./AverageAgeRangePicker.module.css";
import Colors from "../assets/Colors";
import Fonts from "../assets/Fonts";
import { Button } from "../Button/Button";
import { Row, Col } from "react-bootstrap";
import { PriceInput } from "../PriceInput/PriceInput";
import RangePickerWithGraph from "../../components/RangePickerWithGraph/RangePickerWithGraph";
import { LinkButtonWithIcon } from "../LinkButtonWithIcon/LinkButtonWithIcon";
import { ChakraProvider } from "@chakra-ui/react";

export function AverageAgeRangePicker({
  minAndMaxAge = [0, 10],
  setMinAndMaxAge,
  showButtons = true,
  containerClass
}) {
  function minPriceSetter(data) {
    const newArray = minAndMaxAge?.slice();
    newArray[0] = parseInt(data);
    setMinAndMaxAge(newArray);
  }
  function maxPriceSetter(data) {
    const newArray = minAndMaxAge?.slice();
    newArray[1] = parseInt(data);
    setMinAndMaxAge(newArray);
  }
  return (
    <ChakraProvider>
      <div className={`${[classes.card, containerClass && containerClass].join(" ")}`}>
        <Row className={`${[classes.cardFirstRow].join(" ")}`}>
          <Col md={12}>
            <p style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}>
              Age
            </p>
          </Col>
          <Col md={12}>
            <RangePickerWithGraph
              value={minAndMaxAge}
              setValue={setMinAndMaxAge}
              min={10}
              max={1000}
              isMulti={true}
            />
          </Col>
          <Col md={12}>
            <div className={classes.priceInputs}>
              <Row className={classes.dFlexJustifyContentCenter}>
                <Col md={5}>
                  <div className={classes.input}>
                    <PriceInput
                      state={minAndMaxAge[0]}
                      setter={minPriceSetter}
                      customStyle={{ width: "100%" }}
                      prefix={"$"}
                      type={"number"}
                      maxValueLength={4}
                      label={"min age"}
                    />
                  </div>
                </Col>
                <Col md={1} className={classes.dFlexJustifyContentCenter}>
                  <span
                    style={{
                      ...Fonts.input2,
                      lineHeight: "16px",
                      color: Colors.neutralShadesOfNero,
                      margin: 'auto'
                    }}
                  >
                    -
                  </span>
                </Col>
                <Col md={5}>
                  <div className={classes.input}>
                    <PriceInput
                      state={minAndMaxAge[1]}
                      setter={maxPriceSetter}
                      customStyle={{ width: "100%" }}
                      prefix={"$"}
                      type={"number"}
                      maxValueLength={5}
                      label={"max age"}
                    />
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    </ChakraProvider>
  );
}

AverageAgeRangePicker.propTypes = {
  minAndMaxAge: PropTypes.array,
  setMinAndMaxAge: PropTypes.func,
};
AverageAgeRangePicker.defaultProps = {
  minAndMaxAge: [0, 10],
};
